<script>
  // packages
  import { ascending, descending, index } from 'd3-array';

  // local
  import { getColor, NEUTRAL, TIE } from '../colors.js';

  /** @type {import('../types.d').ReadableRace} */
  export let race;

  $: items = determineItems($race);

  function determineItems(
    /** @type {import('../types.d').RaceInterface}*/ race
  ) {
    const candidateRanking = race.candidates.map((d) => d.ap_id);
    const candidateLookup = index(race.candidates, (d) => d.ap_id);

    let noResults = false;
    let tie = false;
    const candidateIds = new Set();

    for (let idx = 0; idx < race.subunits.length; idx++) {
      const subunit = race.subunits[idx];

      // first check if there are votes at all, or not enough in
      if (
        subunit.total_votes <= 0 ||
        subunit.precincts_reporting_percent < 25
      ) {
        noResults = true;
        continue;
      }
      const results = subunit.results
        .slice()
        .sort((a, b) => descending(a[1], b[1]));
      const [leaderApId, leaderVotes] = results[0];
      const [, secondVotes] = results[1];

      // next check if it's a tie
      if (leaderVotes === secondVotes) {
        tie = true;
        continue;
      }

      candidateIds.add(leaderApId);
    }

    const mappedCandidateIds = Array.from(candidateIds).sort((a, b) =>
      ascending(candidateRanking.indexOf(a), candidateRanking.indexOf(b))
    );

    const items = mappedCandidateIds.map((id) => {
      return {
        label: candidateLookup.get(id)?.family_name,
        color: getColor(id),
      };
    });

    if (tie) {
      items.push({
        label: 'Tied',
        color: TIE,
      });
    }

    if (noResults) {
      items.push({
        label: 'No leader',
        color: NEUTRAL,
      });
    }

    return items;
  }
</script>

<div class="legend-items">
  {#each items as item (item.label)}
    <div class="legend-item">
      
      <p class="legend-item-label"><span
        class="circle-pill"
        style="background-color: {item.color}; color: {item.color};"
      />{item.label}</p>
    </div>
  {/each}
</div>
